import { AGENCIA_ADLAB_PERU } from "../constants/permisos";
import { esVentaEnPeriodoBroker } from "./esVentaEnPeriodoBroker";

/**
 * Helpers COMPARTIDOS del filtro de grupo Todos/Visiona/AdLab (Perú-only).
 * Copia de los helpers locales de VentasMiListaClientesV2 (`esBrokerAdLab`, `matchGrupoOpp`),
 * extraídos para reuso (Cartera Clientes, y VentasProyeccion en Fase 2). mis-ventas y
 * VentasDetalle siguen con sus copias locales por ahora (migrarlas es deuda posterior).
 */

/**
 * ¿El cliente es una cuenta brokereada por AdLab? (broker_id === AGENCIA_ADLAB_PERU = 115).
 *
 * En VentasMiListaClientesV2 el helper local además chequeaba `pais === "Perú"` (venía del
 * closure de auth). Acá se omite a propósito: es redundante porque broker_id === 115 (AdLab)
 * es un intermediario Perú-only por diseño de datos, y así queda consistente con
 * `esVentaEnPeriodoBroker` (que también gatea solo por broker_id, sin pais) y la función
 * queda pura. Comparación por ID numérico (regla 8), nunca por nombre.
 *
 * @param {Object|null} cliente - usa cliente.broker_id
 * @returns {boolean}
 */
export const esBrokerAdLab = (cliente) => String(cliente?.broker_id) === String(AGENCIA_ADLAB_PERU);

/**
 * Atribución de grupo (Visiona/AdLab) de UNA oportunidad. `esBTL` distingue pauta vs BTL.
 *  - AdLab: pauta período-aware (`esVentaEnPeriodoBroker`); BTL por CUENTA (`esBrokerAdLab`, sin período).
 *  - Visiona = COMPLEMENTO EXACTO de AdLab por-opp: pauta → !esVentaEnPeriodoBroker; BTL → !esBrokerAdLab.
 *  - Cualquier otro valor (id de persona o "") → true (pass-through, no filtra por grupo).
 *
 * Copia EXACTA de `matchGrupoOpp` de VentasMiListaClientesV2.
 *
 * @param {string} filtro - "grupo:adlab" | "grupo:visiona" | id de persona | ""
 * @param {Object|null} opp - oportunidad (para el chequeo de período en pauta)
 * @param {Object|null} cliente - cliente de la venta (usa broker_id)
 * @param {boolean} esBTL - true si la opp es BTL (atribución por cuenta, sin período)
 * @returns {boolean}
 */
export const matchGrupoOpp = (filtro, opp, cliente, esBTL) => {
  if (filtro === "grupo:adlab") return esBTL ? esBrokerAdLab(cliente) : esVentaEnPeriodoBroker(opp, cliente);
  if (filtro === "grupo:visiona") return esBTL ? !esBrokerAdLab(cliente) : !esVentaEnPeriodoBroker(opp, cliente);
  return true;
};
